import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationConfirmEmail = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationConfirmEmail',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70062)",
    d: "M56.32 0h-1.5c-1.66 0-3 1.34-3 3v31.93h7.5V3c0-1.66-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70062)",
    d: "M59.32 2.46h11.69c5.05 0 9.15 4.1 9.15 9.15 0 5.05-4.1 9.15-9.15 9.15H59.32V2.46Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#E54854",
    d: "m59.26 2.34 7.71 18.3h-7.71V2.34Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70062)",
    d: "M62.45 82.25H45.77v17.72h16.68V82.25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2A44C6",
    d: "M45.77 82.25h16.68v14.76s-1.96-5.38-5.27-8.96c-3.53-3.8-11.41-5.8-11.41-5.8Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70062)",
    d: "M6.89 82.42h85.04c3.87 0 7-3.13 7-7V50.08c0-12.34-10-22.35-22.35-22.35H23.3c-12.34 0-22.35 10-22.35 22.35v26.4a5.94 5.94 0 0 0 5.94 5.94Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4961FF",
    d: "M6.89 82.26H39.6c1.62 0 2.93-1.31 2.93-2.93V48.68c0-11.48-9.31-20.79-20.79-20.79C10.26 27.89.95 37.2.95 48.68v27.64a5.94 5.94 0 0 0 5.94 5.94Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.48 59.53 9.28 10.11 15.11-19.59-5.73-4.38-9.9 12.71-3.34-3.75-5.42 4.9Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70062",
    x1: 51.824,
    x2: 59.319,
    y1: 17.465,
    y2: 17.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70062",
    x1: 72.337,
    x2: 64.72,
    y1: 22.369,
    y2: 1.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FF6A70"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.425,
    stopColor: "#FF6D73"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.741,
    stopColor: "#FF767C"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FF858A"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70062",
    x1: 45.77,
    x2: 62.446,
    y1: 91.111,
    y2: 91.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.003,
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70062",
    x1: 49.939,
    x2: 49.939,
    y1: 19.212,
    y2: 78.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.099,
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.179,
    stopColor: "#E1CDC4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.321,
    stopColor: "#B3ACD6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.463,
    stopColor: "#8D91E5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.603,
    stopColor: "#6F7CF0"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.74,
    stopColor: "#5A6DF8"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.874,
    stopColor: "#4D64FD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationConfirmEmail.displayName = 'ColoredIllustrationConfirmEmail';
export default withProvisionalOverrideFromContext(ColoredIllustrationConfirmEmail);
//# sourceMappingURL=index.js.map